import React, { useMemo } from 'react';
import './FallingDots.css';

const FallingDots = ({ color }) => {
    // Generate a fixed number of dots with random properties
    const dots = useMemo(() => {
        return Array.from({ length: 9 }).map((_, i) => ({
            id: i,
            // Concentrate dots between 15% and 85% to stay closer to the product
            left: `${15 + Math.random() * 70}%`,
            delay: `${Math.random() * 10}s`,
            duration: `${10 + Math.random() * 8}s`,
            size: `${2 + Math.random() * 3}px`,
            opacity: 0.1 + Math.random() * 0.4
        }));
    }, []);

    return (
        <div className="falling-dots-container">
            {dots.map(dot => (
                <div
                    key={dot.id}
                    className="dot"
                    style={{
                        left: dot.left,
                        animationDelay: dot.delay,
                        animationDuration: dot.duration,
                        width: dot.size,
                        height: dot.size,
                        backgroundColor: color,
                        opacity: dot.opacity
                    }}
                />
            ))}
        </div>
    );
};

export default FallingDots;
